import React from 'react';

import { IconMailOpened, IconMail, IconCalendarDue } from '@tabler/icons-react';
import { Button, ListGroup, Row, Col } from 'react-bootstrap';

const moment = require('moment');

const NotificationsCenterListing = (props) => {
  const { current_page, notification_center, updateNotificationStatus } = props;

  const messages = notification_center.map((notification, index) => {
    return (
      <div className={notification.is_read === true ? 'notification read' : 'notification unread'} key={index}>
        <ListGroup className="mb-2">
          <ListGroup.Item>
            <Row className="d-flex align-items-center">
              <Col md="10">
                <p className="mb-1">{notification.message}</p>
                <small className="date d-flex align-items-center justify-content-start" style={{ fontSize: '12px' }}>
                  <IconCalendarDue className="me-2" stroke={1.5} />
                  {moment(notification.created).format('MMM DD, YYYY')}
                </small>
              </Col>
              <Col md="2" align="right">
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() => updateNotificationStatus(notification.id, notification.is_read !== true, current_page)}
                  title={notification.is_read === false ? 'Read Notification' : 'Unread Notification'}
                >
                  {notification.is_read === false ? <IconMail stroke={1.5} /> : <IconMailOpened stroke={1.5} />}
                </Button>
              </Col>
            </Row>
          </ListGroup.Item>
        </ListGroup>
      </div>
    );
  });

  return <div className={`notification-list ${messages.length > 0 ? '' : 'd-none'}`}>{messages}</div>;
};

export default NotificationsCenterListing;
